module.exports = __webpack_public_path__ + "img/1.a8c0dd15.jpg";